<div class="hidden xl:block tab-content" id="homeContent">
  <!-- Contenedor principal del formulario -->
  <h4 class="text-xl font-medium text_white">Datos Personales</h4>
  <div class="w-full max-w-1xl">
    <!-- Contenedor de dos columnas horizontales -->
    <div class="grid grid-cols-2 pt-4 xl:grid-cols-4 xl:gap-6">
      <!-- Columna de la foto de perfil con ancho reducido -->
      <div
        class="card_color px-6 py-10 rounded-lg md:flex md:items-center md:justify-between flex flex-col items-center w-4/4">
        <!-- Imagen de perfil -->

        <div class="relative w-32 h-32">
          <!-- Main Circle with Green Border -->
          <div class="w-full h-full rounded-full border-4 border_customize_card flex items-center justify-center">
            <!-- Avatar Image -->
            <img *ngIf="!loadingPicture" [src]="profilePicture" alt="User Avatar"
              class="w-30 h-30 rounded-full object-cover" />
            <div *ngIf="loadingPicture" role="status"
              class="flex object-cover w-full h-full z-1 justify-center align-content-center items-center">
              <svg aria-hidden="true" style="fill: rgba(52, 211, 153);"
                class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
            </div>
          </div>
          <!-- Badge with Photo-Edit Icon -->
          <button type="button" (click)="triggerFileInput()">
            <div
              class="template_color_customize absolute bottom-0 right-0 w-10 h-10 text_black rounded-full flex items-center justify-center shadow-md">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-photo-edit">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 8h.01" />
                <path d="M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4" />
                <path d="M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3" />
                <path d="M14 14l1 -1c.31 -.298 .644 -.497 .987 -.596" />
                <path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z" />
              </svg>
            </div>

          </button>
          <input #fileInput class="hidden" type="file" id="upload-file" name="upload-file"
            accept="image/png, image/jpeg" ngf-max-size="2MB" (change)="changePicture($event)">
        </div>
      </div>

      <!-- Columna del formulario -->
      <div class="sm:col-span-3 md:col-span-3 lg:col-span-3 xl:col-span-3 2xl:col-span-3">
        <form class="space-y-4" [formGroup]="profileForm">
          <!-- Primera fila: 2 campos de entrada -->
          <div class="grid grid-cols-2 md:grid-cols-2 gap-4">
            <div>
              <!-- Campo de Nombres -->
              <label for="nombres" class="block text-sm font-medium text_gray mb-1">Nombres</label>
              <div class="relative w-full">
                <input maxlength="30" minlength="3" formControlName="firstName" type="text" id="nombres"
                  placeholder="Escribe tus nombres"
                  [ngClass]="profileForm.get('firstName')?.dirty && profileForm.get('firstName')?.hasError('custom') ? 'classwarning': 'noclasswarning'"
                  class="w-full p-3 border_customize_card text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('firstName')?.dirty && profileForm.get('firstName')?.hasError('custom')"
                  class="p-invalid w-full p-1">{{profileForm.get('firstName')?.getError('custom')}}</small>
              </div>
            </div>
            <div>
              <!-- Campo de Apellidos -->
              <label for="apellidos" class="block text-sm font-medium text_gray mb-1">Apellidos</label>
              <div class="relative w-full">
                <input type="text" id="apellidos" placeholder="Escribe tus apellidos" maxlength="30" minlength="3"
                  [ngClass]="profileForm.get('lastName')?.dirty && profileForm.get('lastName')?.hasError('custom') ? 'classwarning': 'noclasswarning'"
                  formControlName="lastName"
                  class="w-full p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('lastName')?.dirty && profileForm.get('lastName')?.hasError('custom')"
                  class="p-invalid w-full p-1">{{profileForm.get('lastName')?.getError('custom')}}</small>
              </div>
            </div>
          </div>

          <!-- Segunda fila: Fecha de nacimiento, Género y Teléfono -->
          <div class="grid grid-cols-3 md:grid-cols-3 gap-4">

            <!-- Campo de Fecha de Nacimiento -->



            <div>
              <label for="fecha" class="block text-sm font-medium text_gray mb-1">Fecha
                de nacimiento</label>
              <div class="relative w-full">

                <app-date-picker formControlName="birthday"
                  [error]="profileForm.get('birthday')?.invalid && profileForm.get('birthday')?.touched ? true: false">
                </app-date-picker>
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('birthday')?.invalid && profileForm.get('birthday')?.touched ? true: false"
                  class="p-invalid">Debes ser mayor a 18 años</small>
                <!-- loading -->
              </div>
            </div>



            <!-- Campo de Género -->
            <!-- Campo de Género -->
            <div>
              <label for="genero" class="block text-sm font-medium text_gray mb-1">Género</label>
              <div class="relative w-full">
                <select id="genero" formControlName="genere"
                  class="w-full p-3 text-md bg_color text_gray rounded-lg focus_line_customize focus_line_color_customize appearance-none cursor-pointer"
                  onchange="this.classList.toggle('text_gray', this.value === ''); this.classList.toggle('text-white', this.value !== '')">
                  <!-- <option value="" disabled selected>Selecciona tu
                    género</option> -->
                  <option *ngFor="let genero of generes_catalog" [value]="genero.id">{{genero.name}}</option>
                </select>

                <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                  <!-- Ícono desplegable -->
                  <svg class="w-5 h-5 text_color_customize" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                    </path>
                  </svg>
                </div>
              </div>
            </div>

            <!-- Campo de Teléfono -->
            <div>
              <label for="telefono" class="block text-sm font-medium text_gray mb-1">Teléfono</label>
              <div class="relative w-full">
                <input type="tel" id="telefono" inputmode="numeric" pattern="[0-9]*" placeholder="Escribe tu teléfono"
                  formControlName="phoneNumber"
                  (input)="sanitizeNumber($event)"
                  [ngClass]="profileForm.get('phoneNumber')?.dirty && profileForm.get('phoneNumber')?.hasError('custom') ? 'classwarning': 'noclasswarning'"
                  class="w-full p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('phoneNumber')?.dirty && profileForm.get('phoneNumber')?.hasError('custom')"
                  class="p-invalid w-full p-1">{{profileForm.get('phoneNumber')?.getError('custom')}}</small>
              </div>
            </div>
          </div>

          <!-- Botón de guardar -->
          <!-- {{loading }}
          {{profileForm.invalid}}
          {{!formIsDifferent}} -->
          <div class="text-left mt-4">
            <button (click)="saveData()" [disabled]="loading || profileForm.invalid"
              class="w-full my-2 block py-2 font-normal text-center text_white group button_color_customize hover:button_color_customize hover:text_black font-medium rounded-lg ">
              <div class="inline-flex items-center">
                Guardar
              </div>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<div class="accordion-content px-4 py-3 text_gray card_color flex xl:hidden">
  <!-- Contenido del acordeón -->

  <div class="w-full max-w-1xl">
    <!-- Contenedor de dos columnas horizontales -->
    <div class="grid grid-cols-1 pt-4 xl:gap-6">
      <!-- Columna de la foto de perfil con ancho reducido -->
      <div class="card_color mb-6 p-6 rounded-lg flex flex-col items-center w-full">
        <!-- Imagen de perfil -->

        <div class="relative w-32 h-32">
          <!-- Main Circle with Green Border -->
          <div class="w-full h-full rounded-full border-4 border_customize_card flex items-center justify-center">
            <!-- Avatar Image -->
            <img *ngIf="!loadingPicture" [src]="profilePicture" alt="User Avatar"
              class="w-30 h-30 rounded-full object-cover" />
            <div *ngIf="loadingPicture" role="status"
              class="flex object-cover w-full h-full z-1 justify-center align-content-center items-center">
              <svg aria-hidden="true" style="fill: rgba(52, 211, 153);"
                class="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500"
                viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor" />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill" />
              </svg>
            </div>
          </div>
          <!-- Badge with Photo-Edit Icon -->
          <button (click)="triggerFileInput()">
            <div
              class="template_color_customize absolute bottom-0 right-0 w-10 h-10 text_black rounded-full flex items-center justify-center shadow-md">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="icon icon-tabler icons-tabler-outline icon-tabler-photo-edit">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M15 8h.01" />
                <path d="M11 20h-4a3 3 0 0 1 -3 -3v-10a3 3 0 0 1 3 -3h10a3 3 0 0 1 3 3v4" />
                <path d="M4 15l4 -4c.928 -.893 2.072 -.893 3 0l3 3" />
                <path d="M14 14l1 -1c.31 -.298 .644 -.497 .987 -.596" />
                <path d="M18.42 15.61a2.1 2.1 0 0 1 2.97 2.97l-3.39 3.42h-3v-3l3.42 -3.39z" />
              </svg>
            </div>
          </button>
          <!-- <input #fileInput class="hidden" type="file" id="upload-file" name="upload-file"
            accept="image/png, image/jpeg" ngf-max-size="2MB" (change)="changePicture($event)"> -->
        </div>

      </div>

      <!-- Columna del formulario -->
      <div class="sm:col-span-3 md:col-span-3 lg:col-span-3 xl:col-span-3 2xl:col-span-3">
        <!-- Formulario visible solo en vista móvil, con diseño de una columna -->
        <div>
          <form class="space-y-4" [formGroup]="profileForm">
            <!-- Campo de Nombres -->
            <div>
              <label for="nombres" class="block text-sm font-medium text_gray mb-1">Nombres</label>
              <div class="relative w-full">
                <input type="text" id="nombres" placeholder="Escribe tus nombres" formControlName="firstName"
                  [ngClass]="profileForm.get('firstName')?.dirty && profileForm.get('firstName')?.hasError('custom') ? 'classwarning': 'noclasswarning'"
                  class="w-full p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('firstName')?.dirty && profileForm.get('firstName')?.hasError('custom')"
                  class="p-invalid w-full p-1">{{profileForm.get('firstName')?.getError('custom')}}</small>
              </div>
            </div>

            <!-- Campo de Apellidos -->
            <div>
              <label for="apellidos" class="block text-sm font-medium text_gray mb-1">Apellidos</label>
              <div class="relative w-full">
                <input type="text" id="apellidos" placeholder="Escribe tus apellidos" formControlName="lastName"
                  [ngClass]="profileForm.get('lastName')?.dirty && profileForm.get('lastName')?.hasError('custom') ? 'classwarning': 'noclasswarning'"
                  class="w-full p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize" />
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('lastName')?.dirty && profileForm.get('lastName')?.hasError('custom')"
                  class="p-invalid w-full p-1">{{profileForm.get('lastName')?.getError('custom')}}</small>
              </div>
            </div>
            <!-- Campo de Fecha de Nacimiento -->

            <div id="formulario-fecha" class="mb-4">
              <label for="fecha-nativa" class="block text-sm font-medium text_gray  mb-1">
                Fecha de nacimiento
              </label>
              <div class="relative">
                <app-date-picker formControlName="birthday"
                  [error]="profileForm.get('birthday')?.invalid && profileForm.get('birthday')?.touched ? true: false">
                </app-date-picker>
                <!-- <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('birthday')?.invalid && profileForm.get('birthday')?.touched ? true: false"
                  class="p-invalid">Debes ser mayor a 18 años</small> -->
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('birthday')?.invalid && profileForm.get('birthday')?.touched && !loading"
                  class="p-invalid">Debes ser mayor a 18 años</small>
              </div>
            </div>

            <!-- Campo de Género -->
            <div>
              <label for="genero" class="block text-sm font-medium text_gray mb-1">Género</label>
              <div class="relative w-full">
                <select id="genero" formControlName="genere"
                  class="w-full p-3 text-md bg_color text_gray rounded-lg focus_line_customize focus_line_color_customize appearance-none cursor-pointer">
                  <option *ngFor="let genero of generes_catalog" [value]="genero.id">{{genero.name}}</option>

                </select>

                <div class="absolute inset-y-0 right-3 flex items-center pointer-events-none">
                  <!-- Ícono desplegable -->
                  <svg class="w-5 h-5 text_color_customize" fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7">
                    </path>
                  </svg>
                </div>
              </div>
            </div>


            <!-- Campo de Teléfono -->
            <div>
              <label for="telefono" class="block text-sm font-medium text_gray mb-1">Teléfono</label>
              <div class="relative w-full">
                <input type="tel" id="telefono" placeholder="Ej: 5512345678" inputmode="numeric" pattern="[0-9]*"
                  formControlName="phoneNumber"
                  [ngClass]="profileForm.get('phoneNumber')?.dirty && profileForm.get('phoneNumber')?.hasError('custom') ? 'classwarning': 'noclasswarning'"
                  class="w-full p-3 text-md bg_color text_white placeholder_gray_customize rounded-lg focus_line_customize focus_line_color_customize"
                  oninput="this.value = this.value.replace(/[^0-9]/g, '')" />
                <small style="color: #FC6161 ;"
                  *ngIf="profileForm.get('phoneNumber')?.dirty && profileForm.get('phoneNumber')?.hasError('custom')"
                  class="p-invalid w-full p-1">{{profileForm.get('phoneNumber')?.getError('custom')}}</small>
              </div>
            </div>

            <!-- Botón de guardar -->
            <div class="text-left mt-4">
              <button type="submit"
                (click)="saveData()"
                [disabled]="loading || profileForm.invalid"
                class="w-full px-6 py-2 template_color_customize text_white font-semibold rounded-md ">
                Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>